import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth-service/auth.service';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import * as moment from 'moment-timezone';
import { SocketService } from '../socket-service/socket-service.service';
import { SharedDataService } from '../shared-service/shared-data.service';

@Injectable()
export class UnAuthorizationGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private socket: SocketService,
    private sharedDataService: SharedDataService,
    private router: Router
  ) {
  }

  // @ts-ignore
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkUserLogin(next);
  }

  checkUserLogin(route: ActivatedRouteSnapshot) {
    const token = localStorage.getItem('token');
    const storedLastActive = localStorage.getItem('last_activity_time');
    const INACTIVITY_LIMIT_MS = 30 * 60 * 1000;

    if (!token) {
      this.sharedDataService.saveUser(null);
      this.socket.disconnectSocket();
      return of(true);
    }

    if (storedLastActive) {
      const parsedLastActive = parseInt(storedLastActive, 10);
      if (!isNaN(parsedLastActive) && parsedLastActive > 0) {
        const elapsed = Date.now() - parsedLastActive;
        if (elapsed >= INACTIVITY_LIMIT_MS) {
          // Inactivity expired while browser was closed -> stay on login page and clear session
          this.sharedDataService.saveUser(null);
          this.socket.disconnectSocket();
          localStorage.removeItem('token');
          localStorage.removeItem('auth-token');
          localStorage.removeItem('last_activity_time');
          return of(true);
        }
      }
    }

    return this.authService.VerifyToken()
      .pipe(
        map((data: any) => {
          if (data.user) {
            this.router.navigate(['/']);
            return false;
          } else {
            this.sharedDataService.saveUser(null);
            this.socket.disconnectSocket();
            localStorage.removeItem('token');
            // this.router.navigate(['/login']);
            return true;
          }
        }),
        catchError((error) => {
          this.sharedDataService.saveUser(null);
          this.socket.disconnectSocket();
          localStorage.removeItem('token');
          // this.router.navigate(['/login']);
          return of(true);
        })
      );

  }
}

